import React, { useState, useEffect } from "react";
import {
  MenuProps,
  Menu,
  Row,
  Col,
  Divider,
  Avatar,
  Typography,
  Space,
  Button,
  Dropdown,
} from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import "./header.scss";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "redux/store";
import { setCollapsed } from "redux/reducer/common";
// import {items} from "./config";
import { BellSVG } from "assets";
import { items } from "./config";
import SelectLanguage from "./components/SelectLanguage/SelectLanguage";
import { useAppDispatch } from "redux/hooks";
// type MenuItem = Required<MenuProps>["items"][number];

type Props = {
  headerMenu: MenuProps["items"] | undefined;
};

const Header: React.FC<Props> = () => {
  // const [current, setCurrent] = useState(headerMenu?.at(0)?.key);
  // const onClick: MenuProps["onClick"] = e => {
  //   setCurrent(e.key);
  // };

  const firstName = localStorage.getItem("firstName");
  const fullName = localStorage.getItem("fullName");
  const dispatch = useAppDispatch();
  const collapsed = useSelector((state: RootState) => state.common.collapsed);
  useEffect(() => {
    dispatch(setCollapsed(true));
    // setCurrent(headerMenu?.at(0)?.key);
  }, []);

  return (
    <div className="header-container">
      <Row justify={"space-between"} align={"middle"}>
        <Col>
          <Space
            direction="horizontal"
            style={{ width: "100%", height: "100%" }}
          >
            <Button
              className="collapsed"
              type="text"
              shape="circle"
              onClick={() => {
                dispatch(setCollapsed(!collapsed));
              }}
              icon={
                collapsed ? (
                  <MenuUnfoldOutlined style={{ color: "white" }} />
                ) : (
                  <MenuFoldOutlined style={{ color: "white" }} />
                )
              }
            />
            <Menu
              className="header-menu no-border"
              // onClick={onClick}
              // selectedKeys={[current as string]}
              mode="horizontal"
            />
          </Space>
        </Col>
        <Col>
          <Space
            style={{ width: "100%", height: "100%" }}
            direction="horizontal"
            split={<Divider type="vertical" />}
          >
            {/* <div>
              <SelectLanguage></SelectLanguage>
            </div>
            <div>
              <BellSVG />
            </div> */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Dropdown arrow={true} menu={{ items }} placement="bottom">
                <Avatar size="default" style={{ backgroundColor: "#CA5442" }}>
                  {firstName?.charAt(0)}
                </Avatar>
              </Dropdown>
              <Typography className="account-name">{fullName}</Typography>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
